import React, { useContext, useEffect, useState } from "react";
import { Badge, Card, CardBody, CardHeader, Col, Row, Spinner, Table } from "reactstrap";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";

const PatientProgress = ()=>{
    const [visits, setVisits] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        const LoadPtientProgress = async ()=>{
            try {
                setVisits([])
            } catch (error) {
                
            }
        }

        LoadPtientProgress()
    },[])

    const statusCount = visits.reduce((acc, visit) => {
        if (visit?.visit_consultation_progress === 'consulted') {
          acc.done += 1;
        } else if (visit?.visit_consultation_progress === 'await') {
          acc.notDone += 1;
        }
        return acc;
      }, { done: 0, notDone: 0 });

    return(
        <React.Fragment>

            {loading && (
                <div className="d-flex justify-content-center">
                    <Spinner size="sm"/>
                </div>
            )}

            <Row>
                <Col>
                    <Card className="card-animate shadow-sm">
                        <CardBody>
                            <div className="d-flex justify-content-between">
                                <div>
                                    {/* <p className="fw-medium text-muted mb-0">Total Consultations</p> */}
                                    <h2 className="mt-4 fs-22 ff-secondary fw-semibold">
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={visits?.length}
                                                // decimals={1}
                                                duration={4}
                                            /></span>
                                    </h2>
                                    <p className="mb-0 text-muted text-truncate">
                                        <span className="badge bg-light text-danger mb-0"></span> Total</p>
                                </div>
                                <div>
                                    <div className="avatar-sm flex-shrink-0">
                                        <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                                            <FeatherIcon
                                                icon="users"
                                                className="text-info"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col>
                    <Card className="card-animate shadow-sm">
                        <CardBody>
                            <div className="d-flex justify-content-between">
                                <div>
                                    {/* <p className="fw-medium text-muted mb-0">Pending Consultations</p> */}
                                    <h2 className="mt-4 fs-22 ff-secondary fw-semibold">
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={statusCount?.notDone}
                                                // decimals={1}
                                                duration={4}
                                            /></span>
                                    </h2>
                                    <p className="mb-0 text-muted text-truncate">
                                        <span className="badge bg-light text-danger mb-0"></span> Pending</p>
                                </div>
                                <div>
                                    <div className="avatar-sm flex-shrink-0">
                                        <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                                            <FeatherIcon
                                                icon="users"
                                                className="text-info"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col>
                    <Card className="card-animate shadow-sm">
                        <CardBody>
                            <div className="d-flex justify-content-between">
                                <div>
                                    {/* <p className="fw-medium text-muted mb-0">Complete</p> */}
                                    <h2 className="mt-4 fs-22 ff-secondary fw-semibold">
                                        <span className="counter-value">
                                            <CountUp
                                                start={0}
                                                end={statusCount?.done}
                                                // decimals={1}
                                                duration={4}
                                            /></span>
                                    </h2>
                                    <p className="mb-0 text-muted text-truncate">
                                        <span className="badge bg-light text-danger mb-0"></span> Complete</p>
                                </div>
                                <div>
                                    <div className="avatar-sm flex-shrink-0">
                                        <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                                            <FeatherIcon
                                                icon="users"
                                                className="text-info"
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </React.Fragment>
    )
}

export default PatientProgress;